<ng-container>
  <div class="group-cell px-[10px]" *ngIf="showTitle">
    <span
      class="cursor-pointer w-full overflow-hidden ellipsis-line-2"
      *ngIf="houseType?.p_id !== -1; else independent"
      (click)="toPropertyTypeDetailPage({ queryParams: { activeIndex: 1, id: houseType.p_id } })">
      {{ houseType.p_title }}
    </span>
    <ng-template #independent>
      <span>{{ houseType.p_title }}</span>
    </ng-template>
    <div
      *ngIf="houseType.p_stop_auto_managed"
      class="stop-auto-managed"
      nz-popover
      nzTrigger="hover"
      [nzPopoverTitle]="''"
      [nzPopoverContent]="typeStopAutoManagedContent"></div>
  </div>
  <div class="house-cell" *ngFor="let house of houseType.p_children; trackBy: trackByHouse">
    <img
      hostPlaceholder
      src="/assets/status/placeholder.svg"
      [delaySrc]="house.c_cover_url"
      class="w-[40px] h-[30px] rounded-[6px] mr-2 shrink-0" />
    <div
      class="name cursor-pointer ellipsis-line-2 leading-[14px]"
      [attr.title]="house.c_title"
      (click)="toPropertyDetailPage({ queryParams: { activeIndex: 1, id: house.c_id } })">
      {{ house.c_title }}
    </div>
    <div class="icon-wrap">
      <div
        *ngIf="house.c_stop_auto_managed"
        class="stop-auto-managed"
        nz-popover
        nzTrigger="hover"
        [nzPopoverTitle]="''"
        [nzPopoverContent]="houseStopAutoManagedContent"></div>
      <!--        脏房-->
      <div
        *ngIf="house.c_cleaning_status === 3 || house.c_cleaning_status === 1"
        [class.opacity]="house.c_cleaning_status === 1"
        class="dirty-house"
        nz-popover
        nzPopoverTrigger="hover"
        nzPopoverPlacement="right"
        [nzPopoverTitle]="''"
        [nzPopoverContent]="dirtyHouseContent"></div>
      <!--        已保洁-->
      <!-- <div
        class="dirty-house opacity"
        *ngIf="house.cleaning_status == 1"
        nz-popover
        nzTrigger="hover"
        nzPopoverPlacement="right"
        [nzPopoverTitle]="''"
        [nzPopoverContent]="dirtyHouseContentClean"
      ></div> -->
    </div>
    <ng-template #houseStopAutoManagedContent>
      <host-auto-popover
        type="house-auto-managed"
        (onClickEditHouseAutoManaged)="
          toPropertyDetailPage({ queryParams: { id: house.c_id, subTab: 1 } })
        "></host-auto-popover>
    </ng-template>
    <ng-template #dirtyHouseContent>
      <host-auto-popover
        type="dirty-house"
        [cleanStatus]="house.c_cleaning_status"
        [hostStyle]="{ 'min-width': '100px' }"
        (onClickUpdateCleanStatus)="updateCleanStatus(house.c_id, $event)"></host-auto-popover>
    </ng-template>
    <!-- <ng-template #dirtyHouseContentClean>
      <host-auto-popover
        type="dirty-house"
        [cleanStatus]="1"
        [hostStyle]="{ 'min-width': '100px' }"
        (onClickUpdateCleanStatus)="updateCleanStatus(house.id, $event)"
      ></host-auto-popover>
    </ng-template> -->
  </div>

  <ng-template #typeStopAutoManagedContent>
    <host-auto-popover
      type="type-auto-managed"
      (onClickEditTypeAutoManaged)="
        toPropertyTypeDetailPage({ queryParams: { id: houseType.p_id, subTab: 1 } })
      "></host-auto-popover>
  </ng-template>
</ng-container>

<!-- 下面的代码应该无用了，因为目前没有免打扫这个状态了 -->
<ng-template #SetCleanStatusTip>
  <div class="host-calendar-set-clean-status">
    <div class="body">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="icon"></i>
      <span class="title">
        <!-- 确认将保洁状态置为 免打扫 吗？ -->
        {{ "warning.confirm_set_no_cleaning" | translate }}
      </span>
      <div class="content">
        <p>
          <!-- 设置后，房间的保洁状态将不再根据入住状态自动变化。 -->
          {{ "warning.set_no_cleaning_info" | translate }}
        </p>
        <label nz-checkbox [(ngModel)]="checked" class="checkbox">
          <!-- 不再提醒 -->
          {{ "word.no_longer_prompt_2" | translate }}
        </label>
      </div>
    </div>
    <div class="footer">
      <button nz-button (click)="modalRef.triggerCancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzType="primary" (click)="modalRef.triggerOk()">
        {{ "word.confirm" | translate }}
      </button>
    </div>
  </div>
</ng-template>
